import {ResetPasswordState} from "@/modules/reset_password_email/types";
import {ActionTree, Module} from "vuex";
import {RootState} from "@/store/types";
import {sendResetPasswordEmail} from "@/services/reset_password_email";

export const state: ResetPasswordState = {
   email: "",
   userType: ""
}

const actions: ActionTree<ResetPasswordState, RootState> = {
    async SEND_RESET_PASSWORD_EMAIL(_, payload) {
      return await sendResetPasswordEmail(payload);
    }
}

export const reset_password_email: Module<ResetPasswordState, RootState> = {
    state,
    actions
  }